// Local storage utility functions

export const storageUtils = {
  /**
   * Save names to local storage
   * @param {Array} names - Array of names to save
   */
  saveNames(names) {
    try {
      localStorage.setItem('wheelNames', JSON.stringify(names));
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  },
  
  /**
   * Load names from local storage
   * @returns {Array} - Array of names or empty array if none found
   */
  loadNames() {
    try {
      const stored = localStorage.getItem('wheelNames');
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error loading from localStorage:', error);
      return [];
    }
  },
  
  /**
   * Save wheel configuration to local storage
   * @param {Object} config - Wheel configuration object
   */
  saveConfig(config) {
    try {
      localStorage.setItem('wheelConfig', JSON.stringify(config));
    } catch (error) {
      console.error('Error saving config to localStorage:', error);
    }
  },
  
  /**
   * Load wheel configuration from local storage
   * @returns {Object} - Wheel configuration or default config if none found
   */
  loadConfig() {
    try {
      const stored = localStorage.getItem('wheelConfig');
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.error('Error loading config from localStorage:', error);
      return null;
    }
  },
  
  /**
   * Clear all wheel data from local storage
   */
  clearAll() {
    try {
      localStorage.removeItem('wheelNames');
      localStorage.removeItem('wheelConfig');
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }
};